import { render, staticRenderFns } from "./ServiceAlert.vue?vue&type=template&id=03893937&scoped=true&"
import script from "./ServiceAlert.vue?vue&type=script&lang=js&"
export * from "./ServiceAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03893937",
  null
  
)

export default component.exports